<template>
  <div class="module_list_2">
    <div class="module_item_2">
      <div class="row">
        <div class="col-lg-3 col-md-3 col-xs-6 col-sm-6">
          <div
            class="m_i_2_1"
            v-for="(item, index) in modulelist"
            :key="item.id"
            v-show="index == 0"
            @click="goproductDetail(item.id)"
          >
            <div class="mo_icon">
              <img :src="item.iconpath" />
            </div>
            <div class="mo_info">
              <div class="mo_title">{{ item.title }}</div>
              <div class="mo_desc">{{ item.subtitle }}</div>
              <div class="mo_price"><i>￥</i>{{ item.show_price }}</div>
              <div class="mo_btn">点击查看</div>
            </div>
          </div>
        </div>
        <div class="col-lg-9 col-md-9 col-xs-6 col-sm-6">
          <div class="row">
            <div
              class="col-lg-4 col-md-6 hidden-xs"
              v-for="(item, index) in modulelist"
              :key="item.id"
              v-show="index > 0"
            >
              <div class="m_i_2_2">
                <div class="m_i_2_2_item" @click="goproductDetail(item.id)">
                  <div class="mo_info">
                    <div class="mo_title">{{ item.title }}</div>
                    <div class="mo_desc">{{ item.subtitle }}</div>
                    <div class="mo_price"><i>￥</i>{{ item.show_price }}</div>
                    <div class="mo_btn">点击查看</div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xs-12 hidden-lg hidden-md hidden-sm"
              v-for="(item, index) in modulelist"
              :key="item.id"
              v-show="index > 0 && index < 3"
            >
              <div class="m_i_2_2">
                <div class="m_i_2_2_item" @click="goproductDetail(item.id)">
                  <div class="mo_info">
                    <div class="mo_title">{{ item.title }}</div>
                    <div class="mo_desc">{{ item.subtitle }}</div>
                    <div class="mo_price"><i>￥</i>{{ item.show_price }}</div>
                    <div class="mo_btn">点击查看</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row hidden-lg hidden-md hidden-sm">
        <div
          class="col-xs-6"
          v-for="(item, index) in modulelist"
          :key="item.id"
          v-show="index > 2"
        >
          <div class="m_i_2_2">
            <div class="m_i_2_2_item" @click="goproductDetail(item.id)">
              <div class="mo_info">
                <div class="mo_title">{{ item.title }}</div>
                <div class="mo_desc">{{ item.subtitle }}</div>
                <div class="mo_price"><i>￥</i>{{ item.show_price }}</div>
                <div class="mo_btn">点击查看</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="module_item_3">
      <div class="row">
        <div
          class="col-lg-6"
          v-for="(item, index) in modulelist"
          :key="item.id"
          v-show="index > 2"
        >
          <div class="m_i_3_1" @click="goproductDetail(item.id)">
            <div class="mo_info">
              <div class="mo_title">{{ item.title }}</div>
              <div class="mo_desc">{{ item.subtitle }}</div>
              <div class="mo_price"><i>￥</i>{{ item.show_price }}</div>
            </div>
            <div class="mo_btn">点击查看</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: ["modulelist"],
  data() {
    return {};
  },
  methods: {
    goproductDetail(id) {
      this.$router.push({
        path: "productdetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
[class*="col-"] {
  padding: 0 0.05rem;
}
.row {
  margin: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/modulelist3.vue